import styled from 'styled-components';

export const StyledMap = styled.div`

  

`
;